const CHURCH_SELECTION = [
  "AC CityHouse Brno",
  "Alive Church",
  "Apostolic Church Czechia",
  "Brokyrkan Sundsvall",
  "C3 Church Hanau Campus Brachttal",
  "Campus Connect Freiburg",
  "Christus Zentrum Celle",
  "Christus-Gemeinde Olpe",
  "Citychurch BFP Kdör",
  "Cirkev Bratrska",
  "Cirkev Bratrska Brno Černošice",
  "Cirkev Bratrska Brno Kounicova",
  "Credo Kirche",
  "EFG Darmstadt",
  "Église BOOM",
  "Elim Kirche Hamburg",
  "Emmanuel Gemeente Deventer",
  "Er-Lebt Gemeinde IM BEFG",
  "FCG Bad Hersfeld",
  "Focus Kirche",
  "Forum Wiedenest",
  "Freie Christengemeinde Bayreuth",
  "Gateway Chapel",
  "Go Church",
  "Gospelhouse Aalen",
  "JosiahVenture",
  "Keldan Church",
  "Kirche 365",
  "LIFE & HOPE Church",
  "Lighthouse Christliches Zentrum",
  "Matthaeus Gemeinde Bremen",
  "Matthäus-Gemeinde Lüneburg",
  "Meine Kirche Regensburg",
  "Motion Church",
  "New Life Church Oberursel",
  "Oxygen Church Bristol",
  "Redemption Church Amersfoort",
  "Redemption Church Rotterdam",
  "Redemption Church Twente",
  "Riverside Kirche",
  "Ruhr City Church",
  "The Believers Centre",
  "The Higher Place Church",
  "Treffpunkt Leben Karlsruhe",
  "Urban Lights Church Frankfurt",
  "Worship Harvest Germany E.V.",
  "Zeal Church"
];

const OTHER_LABEL = "Others";

export const getChurchDropdownItems = () => {
  const selections = CHURCH_SELECTION;
  selections.push(OTHER_LABEL);
  const dropdownItems = selections.map((church) => ({
    value: church,
    label: church,
  }));
  return dropdownItems;
};

export const getResourceFilterButtons = ($t) => {
  return [
    {
      name: "all",
      type: "all",
      typeId: null,
      displayText: "All",
      translatedText: $t("copy.resourcesPage.filterSection.all"),
    },
    {
      name: "gic1-sessions",
      type: "Sessions",
      typeId: 1,
      displayText: "GIC 1",
      translatedText: $t(
        "copy.resourcesPage.filterSection.gic-1-sessions"
      ),
    },
    {
      name: "gic2-sessions",
      type: "Sessions",
      typeId: 2,
      displayText: "GIC 2",
      translatedText: $t(
        "copy.resourcesPage.filterSection.gic-2-sessions"
      ),
    },
    {
      name: "gic3-sessions",
      type: "Sessions",
      typeId: 3,
      displayText: "GIC 3",
      translatedText: $t(
        "copy.resourcesPage.filterSection.gic-3-sessions"
      ),
    },
  ]
};
